query GetCurrentPolicyDocument($policyId: ID!) {
  currentPolicyDocument(policyId: $policyId) {
    policyTitle
    version
    originalFilename
    url
  }
}
